<template>
  <div class="login fccc">
    <div class="container">
      <img class="img-a" src="@/assets/login01.png" alt="">
      <div class="right">
        <div class="close">
          <img class="img-b" src="@/assets/icona02.png" alt="" @click="showLoginTap">
        </div>
        <div class="mform fccc">
          <template v-if="type == 0">
            <div class="title">欢迎登录</div>
            <input class="input-a margin-a" v-model="username" placeholder="手机号码/用户名">
            <input class="input-a margin-a" v-model="password" type="password" placeholder="密码">
            <div class="auth-code">
              <input class="input-b" v-model="authCode" type="text" placeholder="请输入验证码" @keyup.enter="loginTap">
              <img class="get-code" :src="captchaImage" alt="" @click="getCaptchaImage">
            </div>
            <div class="loginbtn" v-on:click="loginTap">登录</div>
            <div>
              <span class="txt-a">还没有账号？</span>
              <span class="txt-b" v-on:click="changeType(1)">去注册</span>
            </div>
          </template>
          <template v-if="type == 1">
            <div class="title-b">欢迎注册</div>
            <input class="input-a margin-a" v-model="phone" type="input" placeholder="手机号码">
            <div class="auth-code margin-a">
              <input class="input-b" v-model="authCode" type="text" placeholder="验证码">
              <span class="get-code" v-on:click="getAuthCode">{{doText}}</span>
            </div>
            <input class="input-a margin-a" v-model="password" type="password" placeholder="请输入6-18位密码">
            <input class="input-a" v-model="username" type="text" placeholder="请输入姓名">
            <div class="input-c">
              <el-radio-group v-model="sex">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
              </el-radio-group>
            </div>
            <div class="loginbtn-b" v-on:click="registerTap">注册</div>
            <div>
              <span class="txt-a">已有账号？</span>
              <span class="txt-b" v-on:click="changeType(0)">去登录</span>
            </div>
          </template>
        </div>
        <div class="instructions">
          <span class="txt-c">登录即同意</span>
          <span class="txt-d">《服务协议》</span>
          <span class="txt-c">&</span>
          <span class="txt-d">《隐私政策》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegularUtil from "@/utils/RegularUtil";
import Auth from "@/utils/Auth"; // 验权
export default {
  name: "Login",
  data () {
    return {
      type: 0, // 0登录 1注册
      second: 59,
      doText: "获取验证码",
      countDownFlag: true,
      captchaImage: "",
      sex: 0,
      uuid: "",
      phone: "",
      authCode: "",
      password: "",
      username: ""
    };
  },
  mounted () {
    this.getCaptchaImage();
  },
  methods: {
    changeType (type) {
      this.type = type;
    },
    loginTap () {
      let that = this;
      if (that.username === "") {
        that.$message.warning("用户账号不能为空");
      } else if (that.authCode === "") {
        that.$message.warning("验证码不能为空");
      } else if (that.password === "") {
        that.$message.warning("密码不能为空");
      } else {
        that.HttpConnection.post("login", {
          username: that.username,
          password: that.password,
          uuid: that.uuid,
          code: that.authCode
        }).then(function (response) {
          that.$store.commit("setShowLogin", false);
          Auth.setToken("Bearer " + response.token);
          that.$store.dispatch("generationRouters");
          that.$message.success("登录成功");
        }).catch((err) => {
          if (err) {
            that.getCaptchaImage()
          }
        })
      }
    },
    registerTap () {
      let that = this;
      if (that.phone === "") {
        that.$message.warning("手机号不能为空");
      } else if (!RegularUtil.telRule.test(that.phone)) {
        that.$message.warning("手机号格式不正确");
      } else if (that.authCode === "") {
        that.$message.warning("验证码不能为空");
      } else if (that.password === "") {
        that.$message.warning("密码不能为空");
      } else if (!RegularUtil.passwordRule.test(that.password)) {
        that.$message.warning("密码必须包含数字、大小写字母，最少6个字符，最多18位");
      } else {
        that.HttpConnection.post("/system-user/register", {
          "password": that.password,
          "nickName": that.username,
          "phonenumber": that.phone,
          "verificationCode": that.authCode,
          "url": "avatar-url",
          "sex": that.sex
        }).then(function (response) {
          that.$store.commit("setShowLogin", false);
          that.$message.success("注册成功，请登录");
          that.type = 1;
        });
      }
    },
    getAuthCode () { // 获取验证码
      let that = this;
      if (that.phone === "") {
        that.$message.warning("手机号不能为空");
      } else if (!RegularUtil.telRule.test(that.phone)) {
        that.$message.warning("手机号格式不正确");
      } else {
        if (that.countDownFlag) {
          that.HttpConnection.get("/send/msg/verification-code", {
            params: {
              phoneNumber: that.phone
            }
          }).then(function (response) {
            that.countDownFlag = false;
            that.countdown(that);
          });
        }
      }
    },
    countdown (that) { // 手机绑定倒计时
      let second = that.second;
      if (second === 0) {
        that.doText = "获取验证码";
        that.second = 59;
        that.countDownFlag = true;
        return;
      }
      let time = setTimeout(function () {
        that.doText = that.second + "秒";
        that.second = second - 1;
        that.countDownFlag = false;
        that.countdown(that);
      }, 1000);
    },
    showLoginTap () {
      this.$store.commit("setShowLogin", false);
    },
    getCaptchaImage () {
      let that = this;
      that.HttpConnection("captchaImage").then(function (response) {
        that.captchaImage = "data:image/gif;base64," + response.img;
        that.uuid = response.uuid;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.login {
  width: 100vw;
  height: 100vh;
  background-color: rgba(204, 204, 204, 0.8);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;
}

.container {
  display: flex;
  flex-direction: row;
}

.right {
  width: 440px;
  height: 480px;
}

.close {
  width: 440px;
  height: 71px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 23px 0px 0px;
  border-radius: 0px 8px 0px 0px;
  background-color: #ffffff;

  .img-b {
    width: 19px;
    height: 18px;
    cursor: pointer;
  }
}

.mform {
  width: 440px;
  height: 361px;
  background-color: #ffffff;
}

.title {
  font-size: 22px;
  color: #333333;
  margin: 0px 0px 32px 0px;
}

.title-b {
  font-size: 22px;
  color: #333333;
  margin: 0px 0px 2px 0px;
}

.img-a {
  width: 320px;
  height: 480px;
  border-radius: 8px 0px 0px 8px;
}

.input-a {
  width: 320px;
  height: 44px;
  border-radius: 4px;
  border: solid 1px #d7dae0;
  font-size: 16px;
  padding: 4px 16px 4px 16px;
}

.input-b {
  width: 190px;
  height: 26px;
  font-size: 16px;
}

.input-c {
  width: 320px;
  height: 36px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.txt-a {
  color: #b3b3b3;
  user-select: none;
}

.txt-b {
  color: #2b59f0;
  user-select: none;
  cursor: pointer;
}

.txt-c {
  color: #b3b3b3;
  user-select: none;
}

.txt-d {
  color: #7a8599;
  user-select: none;
  cursor: pointer;
}

.margin-a {
  margin: 0px 0px 16px 0px;
}

.margin-b {
  margin: 16px 0px 0px 0px;
}

.auth-code {
  width: 320px;
  height: 44px;
  border-radius: 4px;
  border: solid 1px #d7dae0;
  padding: 4px 16px 4px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    font-size: 16px;
    color: #2b59f0;
    padding: 0px 0px 0px 15px;
    border-left: 1px solid #d7dae0;
    user-select: none;
    cursor: pointer;
  }

  .get-code {
    width: 96px;
    text-align: center;
  }
}

.loginbtn {
  width: 320px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #2b59f0;
  border-radius: 4px;
  font-size: 16px;
  color: #ffffff;
  user-select: none;
  cursor: pointer;
  margin: 24px 0px 16px 0px;
}

.loginbtn-b {
  width: 320px;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background-color: #2b59f0;
  border-radius: 4px;
  font-size: 16px;
  color: #ffffff;
  user-select: none;
  cursor: pointer;
  margin: 0px 0px 4px 0px;
}

.instructions {
  width: 440px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  background-color: #f7f8fa;
  border-radius: 0px 0px 8px 0px;
}
</style>